// dev/app-skeleton/src/lib/entry-cache.ts
// D14-DEV-v2 / SEC C' 修：删 plaintext_json 旁路后，所有 UI 读路径走这里：
//   decryptEntryCached(userId, row) → EntryPlaintext
// 命中 LRU 直接返回；未命中 aeadOpen + JSON.parse 后缓存。
// 上限 200 条（覆盖列表 + 编辑 + 搜索常用量；每条平均 < 2KB ≈ 400KB 内存上限）。
// lock() 触发 onLockChange(false) 即清空 → 与 root_key zeroize 同步。
import { onLockChange } from "./session-key";
import { decryptEntry } from "./entries";
const MAX_ENTRIES = 200;
const cache = new Map(); // key = `${userId}:${entryId}`
// lock 触发清缓存
onLockChange((unlocked) => {
    if (!unlocked)
        clearEntryCache();
});
export function clearEntryCache() {
    cache.clear();
}
export function evictEntryCache(userId, entryId) {
    cache.delete(`${userId}:${entryId}`);
}
/** 写入路径直接 prime：upsertEntry 已经有明文，避免下一次读再走一次 AEAD 解密。 */
export function primeEntryCache(userId, entryId, pt, version) {
    const key = `${userId}:${entryId}`;
    touch(key, { pt, v: version, touched: Date.now() });
}
function touch(key, v) {
    v.touched = Date.now();
    // Map 不支持 LRU 原生；超限时按 touched 排序删尾
    if (cache.size > MAX_ENTRIES) {
        const sorted = [...cache.entries()].sort((a, b) => a[1].touched - b[1].touched);
        const drop = sorted.slice(0, cache.size - MAX_ENTRIES);
        for (const [k] of drop)
            cache.delete(k);
    }
    cache.set(key, v);
}
/** 解密 + 缓存。AAD version = (local_known_server_version ?? 0) + 1 与 upsertEntry 写时一致。 */
export async function decryptEntryCached(userId, row) {
    const version = (row.local_known_server_version ?? 0) + 1;
    const key = `${userId}:${row.id}`;
    const hit = cache.get(key);
    if (hit && hit.v === version) {
        touch(key, hit);
        return hit.pt;
    }
    const pt = await decryptEntry(userId, row.id, row.encrypted_blob, version);
    touch(key, { pt, v: version, touched: Date.now() });
    return pt;
}
/** 批量解密（列表/搜索用），失败的行返回 null 占位（UI 自行兜底展示 "(已加密)"） */
export async function decryptEntriesCached(userId, rows) {
    return Promise.all(rows.map(async (row) => {
        try {
            return { row, pt: await decryptEntryCached(userId, row) };
        }
        catch {
            return { row, pt: null };
        }
    }));
}
